<div [formGroup]="formRole" class="custom-container p-1">
    <div class="mb-3">
        <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
            <label class="form-label mb-0 fw-bold text-dark">Seleccionar Menús</label>
            <div class="d-flex align-items-center gap-2">
                <label class="form-label mb-0 fw-bold text-dark">Seleccionar Todos</label>
                <input type="checkbox" class="form-check-input" [checked]="checkedAll" (change)="changeAll()">
            </div>
        </div>

        <ng-select
            [items]="processedMenus()"
            [multiple]="true"
            [selectableGroup]="true"
            groupBy="groupLabel"
            [hideSelected]="true"
            [closeOnSelect]="false"
            [selectableGroupAsModel]="false"
            bindLabel="label"
            [compareWith]="compareById"
            formControlName="menus"
            placeholder="Escribe para buscar..."
            [virtualScroll]="true"
            (change)="onMenusChange($event)">

            <ng-template ng-option-tmp let-item="item">
                <div class="d-flex justify-content-between">
                    <span>{{ item.label }}</span>
                </div>
            </ng-template>

            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                @for (item of items; track (item.uuid || item.id || item.key)) {
                <div class="ng-value">
                    <span class="ng-value-label">{{ item.label }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                </div>
                }
            </ng-template>

            <ng-template ng-footer-tmp>
                <div class="p-2 border-top small">
                    <span class="text-info"><i class="fas fa-info-circle"></i></span>
                    Menús seleccionados: <strong>{{ formRole.get('menus')?.value?.length || 0 }}</strong>
                </div>
            </ng-template>
        </ng-select>
    </div>
</div>
